import EventEmitter from 'wolfy87-eventemitter';
import { NOTIFICATION_EVENTS } from '../../../constants/CONTROLLERS_EVENT_TYPES';

interface Message {
  title?: string;
  message: string;
}

export class NotificationController extends EventEmitter {
  notification: Object = null;

  notifications: Array<any> = [];

  timeout: any;

  constructor() {
    super();

    this.show = this.show.bind(this);
    this.hide = this.hide.bind(this);
    this.updateTimeout = this.updateTimeout.bind(this);

    document.addEventListener('mouseenter', this.updateTimeout);
  }

  updateTimeout() {
    if (this.notifications.length) {
      this.notifications = [];
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.hide();
      }, 5000);
    }
  }

  show(message: Message, type: string) {
    this.notification = { ...message, type };

    this.emit(NOTIFICATION_EVENTS.UPDATE, this.notification);

    this.notifications.push(message);
  }

  hide() {
    this.notification = null;

    this.emit(NOTIFICATION_EVENTS.UPDATE, this.notification);

    clearTimeout(this.timeout);
  }

  info(message: Message) {
    this.show(message, 'info');
  }

  success(message: Message) {
    this.show(message, 'success');
  }

  warning(message: Message) {
    this.show(message, 'warning');
  }

  error(message: Message) {
    this.show(message, 'error');
  }
}
